import React, { useEffect } from 'react';
import classNames from 'classnames';
import styles from './assets/adminWork-info.module.scss';

import { IAdminWork } from 'src/types/adminWork';
import RoleLayout from 'src/components/layout/RoleLayout';
import { RouteComponentProps } from 'react-router';

export interface StateProps {
    adminWork: Partial<IAdminWork> | null;
}

export interface DispatchProps {
    getData: (id: string | number) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const AdminWorkInfo: React.FunctionComponent<Props> = ({
    adminWork,
    getData,
    match: {
        params: { id },
    },
}: Props) => {
    useEffect(() => {
        if (id) {
            getData(id);
        }
        // eslint-disable-next-line
    }, [getData]);

    if (!adminWork) {
        return null;
    }
    return (
        <RoleLayout>
            <div>
                <h2>ADMIN WORKS {`>`}</h2>
            </div>

            <div className={classNames(styles.infoWrap)}>
                <div className={classNames(styles.infoItems)}></div>
            </div>
        </RoleLayout>
    );
};

export default AdminWorkInfo;
